export enum AccountErrorCodes {
  USER_DOES_NOT_EXIST = 3108,
  AD_USERS_CANNOT_DELETE_PLATFORM_MANAGERS_ACCOUNTS = 3109,
  USER_DOES_NOT_EXIST_OR_DO_NOT_HAVE_PERMISSION = 3110,
  COMPANY_DOES_NOT_EXIST_OR_IS_NOT_ACCESSIBLE = 3111,
}
